export interface ProblemDetails {
  type?: string;
  title: string;
  status: number;
  detail?: string;
  code?: string;
  instance?: string;
  invalid_params?: Array<{
    name: string;
    reason: string;
  }>;
}

export function isProblemDetails(value: unknown): value is ProblemDetails {
  return (
    typeof value === 'object' &&
    value !== null &&
    'status' in value &&
    'title' in value &&
    typeof (value as Record<string, unknown>).title === 'string' &&
    typeof (value as Record<string, unknown>).status === 'number'
  );
}

export function getProblemErrorMessage(problem: ProblemDetails): string {
  if (problem.detail) {
    return problem.detail;
  }
  if (problem.invalid_params && problem.invalid_params.length > 0) {
    return problem.invalid_params.map((p) => `${p.name}: ${p.reason}`).join(', ');
  }
  return problem.title;
}
